import type { InternalAxiosRequestConfig, Method } from 'axios';

export interface logRequestBody {
  type: string;
  url: string;
  method?: Method;
  headers: any;
  params?: any;
  dateTimeRequest: string;
  data?: any;
}

export default function (
  request: InternalAxiosRequestConfig<any>,
  start: Date
): logRequestBody {
  const size = import.meta.env.VITE_LOG_SIZE || '0';
  const sendRequest: logRequestBody = {} as logRequestBody;

  // Добавление минимального набора информации
  sendRequest.type = 'request';
  sendRequest.url = request.url || '';
  sendRequest.headers = request.headers;
  sendRequest.params = request.params;
  // @ts-ignore
  sendRequest.method = request.method;
  sendRequest.dateTimeRequest = start.toString();

  // Добавление базового набора информации
  if (size === '1' || size === '2') {
    sendRequest.data = request.data;
  }
  return sendRequest;
}
